import React from 'react';
import { Outlet } from 'react-router-dom';

const Customers = () => (
  <Outlet />
);

export default Customers;
